import { render, staticRenderFns } from "./contentGenerator.vue?vue&type=template&id=7b4c87ec"
import script from "./contentGenerator.vue?vue&type=script&lang=js"
export * from "./contentGenerator.vue?vue&type=script&lang=js"
import style0 from "./contentGenerator.vue?vue&type=style&index=0&id=7b4c87ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports